"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { useLanguage } from "../../../../../hooks/useLanguage.js";
import Group from "../../../../layout/Group/Group.js";
import { RemoveScroll, ScrollArea } from "@mantine/core";
import LinkList from "./parts/LinkList.js";
import OtherSites, { F as FullscreenNavStyles } from "./parts/OtherSites.js";
import { resolveUser } from "../../Header.helpers.js";
const FullscreenNav = (props) => {
  const {
    links,
    globalLinks,
    user,
    languages,
    isOpen,
    openMenu,
    showUserLogin,
    actionLink,
    ...rest
  } = props;
  const { oppositeLang } = useLanguage();
  const resolvedUser = showUserLogin ? [resolveUser(user)] : [];
  const languageLink = languages == null ? void 0 : languages.find((item) => item.code === oppositeLang.code);
  const languageAccordionLink = {
    header: languageLink == null ? void 0 : languageLink.label,
    href: languageLink == null ? void 0 : languageLink.href,
    icon: "World"
  };
  const resolvedActionLink = {
    header: actionLink == null ? void 0 : actionLink.text,
    href: actionLink == null ? void 0 : actionLink.href
  };
  const resolvedLinks = [
    ...resolvedUser,
    ...!showUserLogin ? [resolvedActionLink] : [],
    ...links || [],
    ...languageLink ? [languageAccordionLink] : []
  ];
  return isOpen && /* @__PURE__ */ jsx(RemoveScroll, { children: /* @__PURE__ */ jsx(
    Group,
    {
      ...rest,
      direction: "column",
      className: FullscreenNavStyles.navigation,
      p: 0,
      hiddenFrom: "lg",
      children: /* @__PURE__ */ jsxs(ScrollArea, { children: [
        /* @__PURE__ */ jsx(Group, { className: FullscreenNavStyles.container, direction: "column", children: /* @__PURE__ */ jsx(LinkList, { links: resolvedLinks, openMenu }) }),
        /* @__PURE__ */ jsx(OtherSites, { globalLinks })
      ] })
    }
  ) });
};
export {
  FullscreenNav as default
};
